import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { DepartmentService } from 'src/app/services/department.service';
import { environment } from 'src/environments/environment';
import { TableColumn } from 'src/app/common/table/table-column.model';
import { tableResource } from 'src/app/common/table/table-resource';
import { CfgTableComponent } from 'src/app/common/table/table.component';
import { TemplateListItem } from '../template.model';

@Component({
    selector: 'app-template-list',
    templateUrl: './template-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CfgTableComponent]
})
export class TemplateListComponent {

  private readonly departmentService = inject(DepartmentService);
  private readonly commonService = inject(CommonService);

  protected readonly templatesResource = tableResource<TemplateListItem>(() => {
    const department = this.departmentService.selectedDepartment();
    if (!department?.id || department.id === this.commonService.guidEmpty()) {
      return undefined;
    }
    return `${environment.adminConfig.apiUri}/template/list/${department.id}`;
  });

  protected readonly columns: TableColumn<TemplateListItem>[] = [
    { key: 'name', header: 'Navn', width: '300px' },
    { key: 'description', header: 'Beskrivelse', width: '300px' },
    { key: 'dbObjectName', header: 'Tabelnavn' },
    { key: 'enabled', header: 'Aktiv', width: '200px', value: item => (item.enabled ? 'Ja' : 'Nej') },
  ];

  protected readonly defaultSort = { key: 'name', direction: 'asc' } as const;
  protected readonly trackById = (item: TemplateListItem) => item.id;
  protected readonly rowLink = (item: TemplateListItem) => ['/template', item.id];
}
